import { create } from 'zustand';
import { countOrdiniAttivi } from '../api/richieste';

interface OrdiniCountState {
  count: number;
  isLoading: boolean;
  refetch: () => Promise<void>;
}

export const useOrdiniCountStore = create<OrdiniCountState>((set) => ({
  count: 0,
  isLoading: false,
  refetch: async () => {
    set({ isLoading: true });
    try {
      const count = await countOrdiniAttivi();
      set({ count, isLoading: false });
    } catch {
      set({ isLoading: false });
    }
  },
}));
